import { getInternationalEventDetail } from 'api/internationalEvents';
import { useQuery } from 'react-query';

/** Single international event by id; disabled until `id` is set. */
export const useInternationalEventDetailQuery = (id: number | string | undefined, enabled = true) =>
  useQuery(['internationalEvent', id], () => getInternationalEventDetail(id as number | string), {
    enabled: Boolean(id) && enabled,
  });
